import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService } from '@services/app.service';
import { SettingService } from '@services/setting/setting.service';
import { environment } from 'environments/environment';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-ngx';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '@services/auth/auth.service';
@Component({
  selector: 'app-menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.scss'],
})
export class MenuSidebarComponent implements OnInit {
  @ViewChild('osComponentRef2', { read: OverlayScrollbarsComponent })
  osComponentRef: OverlayScrollbarsComponent;
  public isCollapse: boolean = false;
  public isInventoryCollapse: boolean = false;
  public isBuyersCollapse: boolean = false;
  public isAuctionsCollapse: boolean = false;
  public isCMSCollapse: boolean = false;
  public isUserCollapse: boolean = false;
  public env = environment.forntend_url;
  public role: any;

  constructor(
    public appService: AppService,
    public settingService: SettingService,
    public router: Router,
    public toastr: ToastrService,
    public authService: AuthService
  ) {
    let get_user = JSON.parse(localStorage.getItem('user'));
    let user_id = get_user['data']['user_id'];

    this.settingService.userRolePermissionList(user_id).subscribe(
      (res) => {
        let data = res['data'];
        let getLastIndexData = data.length - 1;
        this.role = data[getLastIndexData];

        if (!res['success']) {
          this.toastr.warning(res['errors']);
        }
      },
      (error: HttpErrorResponse) => {
        if (error.error.message == 'The incoming token has expired') {
          this.router.navigate(['/']);
        } else {
          this.toastr.warning(error.statusText);
        }
      }
    );
  }

  ngOnInit() {}
}
